import styled from 'styled-components';

export const ChangePasswordStyled = styled.div`
  max-width: 500px;
  & .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .btn-update {
    display: flex;
    justify-content: flex-end;
  }
  & .setting-title {
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      display: none;
    }
  }
`;
